// Import React and necessary hooks
import React, { useEffect, useState, useRef } from 'react';
// Import the modal component
import CreateDozerCoinsModal from './CreateDozerCoinsModal';
import { useAuth } from '../../../contexts/auth.context';

// DozerCoin component
const DozerCoin = () => {
  const [showModal, setShowModal] = useState(false);
  const { auth } = useAuth();

  const authToken = useRef(auth?.idToken); // Create a ref for the auth?.idToken

  useEffect(() => {
    authToken.current = auth?.idToken; // Update the ref with the latest value of auth?.idToken
  }, [auth?.idToken]);

  return (
    <div className="container">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center border-bottom">
        <div>
          <div className="game-micro">reward station</div>
          <h4 className="mb-0">Dozer Rewards</h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <button type="button" className="btn btn-primary" onClick={() => setShowModal(true)}>
            Create Dozer Coin
          </button>
        </div>
      </div>
      <CreateDozerCoinsModal
        show={showModal}
        token={authToken.current}
        onHide={() => setShowModal(false)}
      />
    </div>
  );
};

// Export the DozerCoin component
export default DozerCoin;
